import React from 'react';
import { Card, ListGroup, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
  ClockIcon,
  DocumentIcon,
  DocumentSearchIcon,
  DocumentTextIcon,
  DocumentReportIcon,
  BeakerIcon,
} from '@heroicons/react/solid';

const IconByProcessType = {
  MEDICAL_DOCUMENT: DocumentSearchIcon,
  DOCUMENT_REPORT: DocumentTextIcon,
  HEALTH_REPORT: DocumentReportIcon,
  SKIN_CLASSIFY: BeakerIcon,
};

const CreditsHistoryItem = ({ creditCounter }) => {
  const { t } = useTranslation();

  const Icon = IconByProcessType[creditCounter?.process_type] || DocumentIcon;

  return (
    <ListGroup.Item className='border-o'>
      <Row className='ps-lg-1'>
        <Col xs='auto'>
          <div className={`icon-shape icon-xs icon-shape-success rounded`}>
            <Icon />
          </div>
        </Col>
        <Col className='ms-n2 mb-3'>
          <h3 className='fs-6 fw-bold mb-1'>
            {t(`account.credits.process-type.${creditCounter.process_type}`)}
          </h3>
          <Card.Text className='mb-1'>
            {t('account.credits.date')}: {moment(creditCounter.created).format('LL')}
          </Card.Text>
          <div className='d-flex align-items-center'>
            <ClockIcon className='icon icon-xxs text-gray-400 me-1' />
            <small>{moment(creditCounter.created).fromNow()}</small>
          </div>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

export default React.memo(CreditsHistoryItem);
